
import decodeJwt from 'jwt-decode';
import { getApiUrl } from './utils/getApiUrl';
import {
    clearAuthSession,
    getAuthPermissions,
    getAuthToken,
    setAuthSession,
} from './utils/authStorage';

export default {
    login: ({ username, password }) => {
        const request = new Request(`${getApiUrl()}/auth/login`, {
            method: 'POST',
            body: JSON.stringify({ email: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error("Username or password incorrect");
                }
                return response.json();
            })
            .then(({ token }) => {
                const decodedToken = decodeJwt(token);
                setAuthSession(token, decodedToken.permissions);
            });
    },
    logout: () => {
        clearAuthSession();
        return Promise.resolve();
    },
    checkError: error => {

        const status = error.status;
        if (status === 401 || status === 403) {
            clearAuthSession();
            return Promise.reject();
        }
        return Promise.resolve();

    },
    checkAuth: () => {
        return getAuthToken() ? Promise.resolve() : Promise.reject();
    },
    getPermissions: () => {

        const role = getAuthPermissions();
        return role ? Promise.resolve(role) : Promise.reject();
    }
};
